import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import {GreenButton, OrangeButton} from "../common/ButtonsConstants";
import {
    deletePositionDescriptions,
    positionDescriptions,
    saveOrUpdatePositionDescriptions
} from "../../util/ApiUtils";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    'input': {
    '&::placeholder': {
        textOverflow: 'ellipsis !important',
        background: 'yellow'
    }
},
}));

const columns = [
    /*{
        name: 'Identifier',
        id: 'identifier',
        type: "text",
    },*/
    {
        name: t('context.position.columns.jobTitle'),
        id: 'jobTitle',
        type: "text",
    },
    {
        name: t('context.position.columns.location'),
        id: 'location',
        type: "text",
    },
    {
        name: t('context.position.columns.supervisor'),
        id: 'supervisor',
        type: "text",
    },
];

class PositionDescriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            positionDescriptions: [],
            id: null,
            isLoading: true,
            isEditing: false,
            show: false,
            identifier: "",
            jobTitle: "",
            location: "",
            supervisor: "",
            duties: "",
            qualifications: "",
            experience: "",
            skills: "",
            performanceGoals: "",
        };
        this.loadPositionDescriptions = this.loadPositionDescriptions.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    componentDidMount() {
        this.loadPositionDescriptions();
    }

    loadPositionDescriptions() {
        positionDescriptions()
            .then(response => {
                console.log('review', response);
                this.setState({
                    positionDescriptions: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(jobDescrition) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: jobDescrition.id,
            header: `${jobDescrition.jobTitle}`,
            jobTitle: jobDescrition.jobTitle,
            location: jobDescrition.location,
            supervisor: jobDescrition.supervisor,
            duties: jobDescrition.duties,
            qualifications: jobDescrition.qualifications,
            experience: jobDescrition.experience,
            skills: jobDescrition.skills,
            performanceGoals: jobDescrition.performanceGoals,
        });
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            id: null,
            identifier: "",
            jobTitle: "",
            location: "",
            supervisor: "",
            duties: "",
            qualifications: "",
            experience: "",
            skills: "",
            performanceGoals: "",
            header: t('context.position.newRecord'),
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            id: null,
            identifier: "",
            jobTitle: "",
            location: "",
            supervisor: "",
            duties: "",
            qualifications: "",
            experience: "",
            skills: "",
            performanceGoals: "",
            header: t('context.position.newRecord'),
        });
        this.loadPositionDescriptions();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        deletePositionDescriptions(record)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('context.position.removedSuccess'), 5000);
                this.reset();
            }).catch(error => {
            NotificationManager.error(t('app.notifications.error'), t('context.position.error'), 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdatePositionDescriptions(this.state)
        .then((updatedRecord) => {
            NotificationManager.success(t('app.notifications.success'), t('context.position.updatedSuccess'), 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('context.position.error'), 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return (
            <div>
                <Typography component="h2" variant="h5">{t('context.position.title')}</Typography>
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    {!state.isEditing ? (
                        <div>
                            {!isDemo && !isViewer && (
                                <GreenButton
                                    startIcon={<SystemUpdateAltTwoTone/>}
                                    onClick={() => exportReport('/position-descriptions/export')}
                                    style={{ float: 'right', marginRight: '160px' }}
                                >
                                    {t('context.position.export')}
                                </GreenButton>
                            )}
                            <TableComponent
                                tableKey="positionDescriptionsTable"
                                data={state.positionDescriptions}
                                columns={columns}
                                handleSubmit={this.handleSubmit}
                                handleAddRow={this.handleAddRow}
                                handleRowDel={this.onDelete}
                                handleRowEdit={this.onEdit}
                                allowAdd={(!isAuditor && !isViewer) ? 'show' : 'disable'}
                                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                                pagination={true}
                            />
                        </div>
                    ) : (
                        <div style={{ paddingLeft: '30px', paddingRight: '30px', paddingBottom: '30px' }}>
                            <div>
                                <TextField
                                    id="jobTitle"
                                    name="jobTitle"
                                    value={state.jobTitle}
                                    label={t('context.position.jobTitle')}
                                    onChange={this.handleTextChange}
                                    placeholder={t('context.position.placeholders.jobTitle')}
                                    style={{ width: '600px' }}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="location"
                                    name="location"
                                    value={state.location}
                                    label={t('context.position.location')}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    placeholder={t('context.position.placeholders.location')}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="supervisor"
                                    name="supervisor"
                                    value={state.supervisor}
                                    label={t('context.position.supervisor')}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    placeholder={t('context.position.placeholders.supervisor')}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="duties"
                                    name="duties"
                                    value={state.duties}
                                    label={t('context.position.dutiesLabel')}
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    placeholder={t('context.position.placeholders.duties')}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <h4 style={{ paddingTop: '20px' }}>{t('context.position.skillsAndExperience')}</h4>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="qualifications"
                                    name="qualifications"
                                    value={state.qualifications}
                                    label={t('context.position.qualifications')}
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    placeholder={t('context.position.placeholders.qualifications')}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="experience"
                                    name="experience"
                                    value={state.experience}
                                    label={t('context.position.experience')}
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="skills"
                                    name="skills"
                                    value={state.skills}
                                    label={t('context.position.skills')}
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <TextField
                                    id="performanceGoals"
                                    name="performanceGoals"
                                    value={state.performanceGoals}
                                    label={t('context.position.performanceGoals')}
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: '600px' }}
                                    InputProps={{ classes: { input: this.props.classes['input'] } }}
                                />
                            </div>
                            <div style={{ width: '800px', clear: 'both', paddingTop: '30px' }}>
                                <OrangeButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onCancel}
                                    style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px', float: 'left' }}
                                >
                                    {t('context.position.cancel')}
                                </OrangeButton>
                                <GreenButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onSave}
                                    style={{ marginTop: '20px', marginBottom: '20px', float: 'left' }}
                                >
                                    {t('context.position.save')}
                                </GreenButton>
                            </div>
                        </div>
                    )}
                </Paper>
                <NotificationContainer />
            </div>
        );
    }
 }

 export default withStyles(classes)(PositionDescriptions);
